import axios from "axios";
import {BASE_URL} from "@/constant";

const url = `${BASE_URL}/api`;

const jwtConfig = () => ({
    headers: {
        Authorization: "Bearer " + localStorage.getItem('jwt'),
    },
});
export default {
    save(department) {
        return axios.post(`${url}/department`, department, jwtConfig());
    },
    update(department) {
        return axios.put(`${url}/department`, department, jwtConfig());
    },
    delete(department) {
        return axios.delete(`${url}/department/${department.id}`, jwtConfig());
    },
    getAll(pageable, criteria) {
        let resUrl = pageable
            ? `?page=${pageable.page}&size=${pageable.size}&sort=${pageable.sortBy},${pageable.sort}`
            : "-list";
        if (criteria != null) {
            resUrl += criteria.name ? `&name=${criteria.name}` : "";
        }
        return axios.get(`${url}/user/department${resUrl}`);
    },
    getOne(id) {
        return axios.get(`${url}/user/department/${id}`);
    },
};
